import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";

const lisaPreset = definePreset(Aura, {
  primitive: {
    borderRadius: {
      none: "0",
      xs: "2px",
      sm: "4px",
      md: "4px",
      lg: "4px",
      xl: "6px",
    },
  },
  semantic: {
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
  },
});

export const lisaPrimeVueConfig = {
  ripple: false,
  theme: {
    preset: lisaPreset,
    options: {
      darkModeSelector: ".fake-dark-selector",
      cssLayer: {
        name: "primevue",
        order: "tailwind-base, primevue, tailwind-utilities",
      },
    },
  },
};
